import { render, staticRenderFns } from "./ReVerifyEmail.vue?vue&type=template&id=f6f8141c&scoped=true&"
import script from "./ReVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./ReVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./ReVerifyEmail.vue?vue&type=style&index=0&id=f6f8141c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f8141c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
